import { createSlice } from '@reduxjs/toolkit';

const initialState = false;

const mobileViewSlice = createSlice({
	name: 'mobileView',
	initialState,
	reducers: {
		setMobile: () => {
			return true;
		},
		setDesktop: () => {
			return false;
		}
	}
});

export const { setMobile, setDesktop } = mobileViewSlice.actions;
export default mobileViewSlice.reducer;
